import ResponseAttribution from "./ResponseAttribution";
import ResponseText from "./ResponseText";
import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../../../backend/firebaseConfig";
import dayjs from "dayjs";
import "../../../../../css/Compliance/Chatbot/CachedResponses.css";
import NewTextArea from "../../../../DesignSystem/Inputs/NewTextArea";
import ButtonTextLink from "../../../../DesignSystem/Buttons/ButtonTextLink";
import "../../../../../css/Enquiries/EnquiriesList.css";
import { useUserEmail } from "../../../../SignIn/UserEmailContext";

const RejectedResponses = ({ searchTerm = "" }) => {
  const [responses, setResponses] = useState([]);
  const [newRemarks, setNewRemarks] = useState({}); // per-response editable remarks
  const COMPLIANCE_CHATBOT_URL = process.env.REACT_APP_COMPLIANCE_CHATBOT_URL;
  const { userEmail } = useUserEmail();

  const fetchResponses = async () => {
    const snapshot = await getDocs(
      collection(db, "Compliance", "Cached Responses", "Incorrect Responses")
    );
    const data = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    const sorted = data
      .sort((a, b) => {
        const dateA = new Date(a.timestamp);
        const dateB = new Date(b.timestamp);
        return dateB - dateA;
      })
      .sort((a, b) => {
        const aEmpty = !a.remarks?.trim();
        const bEmpty = !b.remarks?.trim();
        return aEmpty === bEmpty ? 0 : aEmpty ? -1 : 1;
      });

    setResponses(sorted);
  };

  useEffect(() => {
    fetchResponses();
  }, []);

  const handleReject = async (
    question,
    answer,
    suggestedAnswer,
    requestedBy,
    rejectedBy, // default to current user if not provided
    remarks
  ) => {
    await fetch(`${COMPLIANCE_CHATBOT_URL}/api/reject`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        question,
        answer,
        requestedBy,
        rejectedBy,
        suggestedAnswer: suggestedAnswer.trim() || "No suggestion provided",
        remarks: remarks.trim() || "",
      }),
    });

    fetchResponses();
  };

  return (
    <div className="chatbot-responses table-scroll-container">
      <table className="website-table ain-history-table"><thead>
      <tr >
        <th className="FP_Help_Text_Semibold table-index-column"></th>
        <th className="FP_Help_Text_Semibold">PROMPT</th>
        <th className="FP_Help_Text_Semibold">RESPONSE</th>
        <th className="FP_Help_Text_Semibold">COMMENTS</th>
      </tr></thead><tbody>

      {responses.filter(({ id, question, answer, suggestedAnswer, remarks, requestedBy, rejectedBy }) =>
        [question, answer, suggestedAnswer, newRemarks[id] ?? remarks, requestedBy, rejectedBy]
          .some((value) => String(value ?? "").toLowerCase().includes(searchTerm.trim().toLowerCase()))
      ).map(
        (
          {
            id,
            question,
            answer,
            timestamp,
            rejectedBy,
            requestedBy,
            suggestedAnswer,
            remarks,
          },
          index
        ) => (
          <tr  key={id}>
            <td className="FP_Content table-index-column">
              {index + 1}.
            </td>

            <td className="FP_Content">
              <div className="Content">{question}</div>
              <ResponseAttribution label="Rejected by" value={rejectedBy} />
              <ResponseAttribution label="Requested by" value={requestedBy} />
              <div className="Content-Small">
                {dayjs(timestamp).format("DD/MM/YYYY")}
              </div>
            </td>

            <td className="FP_Content">
              Generated Response:
              <ResponseText answer={answer} />
              Suggested Response:
              <div className="Content">
                {suggestedAnswer || "No suggestion provided"}
              </div>
            </td>

            <td className="FP_Content">
              <div className="input-container" >
                <NewTextArea
                  id={`response-comments-${id}`}
                  value={newRemarks[id] ?? remarks ?? ""}
                  placeholder="Add notes..."
                  onChange={(e) => {
                    setNewRemarks((prev) => ({
                      ...prev,
                      [id]: e.target.value,
                    }));
                  }}
                />
                <ButtonTextLink
                  onClick={() => {
                    const remark = newRemarks[id] ?? remarks ?? "";
                    // console.log("Remarks for", id, ":", remark);
                    handleReject(
                      question,
                      answer,
                      suggestedAnswer,
                      requestedBy,
                      rejectedBy,
                      remark
                    );
                  }}
                >
                  Save
                </ButtonTextLink>
              </div>
            </td>
          </tr>
        )
      )}</tbody></table>
    </div>
  );
};

export default RejectedResponses;
